<template lang="html">
  <div class="imatap-page">
    <div class="container">
      <img src="/images/IMATAP WEBINAR BY DOCKING.ID.png">
      <h1>
        IMATAP WEBINAR
      </h1>

      <h2>Persaingan Digital Marketing pada Industri Maritim Saat Pandemi</h2>
      <p>
        Sebagai negara maritime, Indonesia pada kenyataannya  belum sepenuhnya memanfaatkan internet ( digital ) untuk mendukung perkembangan usaha dibidang Maritime. Hal ini dikarenakan para pelaku bisnis maritime belum banyak yang mengetahui tingkat efektifitas dan effisiensi yang dapat didapatkan dari penggunaan <em>digital</em>.
        <br><br>Webminar ini bertujuan untuk menciptakan ekosistem bisnis maritim yang dapat memaksimalkan penggunaan digital sebagai sarana pengembangan bisnis.
        Manfaat yang anda dapatkan adalah memberikan :
        <ul>
          <li>1. Gambaran kondisi digital maritime di Indonesia</li>
          <li>2. Pemahaman dasar terkait manfaat digital marketing</li>
          <li>3. Cara memaksimalkan digital selama pandemi</li>
        </ul>
      </p>
      <div class="row">
        <div class="col-lg-6 info">
          <h3>Speaker:</h3>
          <p><b>Andin Rahmana</b> <br>
          <em>Digital Marketing Lecturer at Purwadhika Startup <br>
          School & CEO Cikalbakal Digital Agency</em><br><br></p>
          <h3>Moderator:</h3>
          <p><b>Tjahjono Roesdianto</b> <br>
          <em>Praktisi Industri Maritim</em></p>
        </div>
        <div class="col-lg-6 jadwal">
          <h3>Jadwal</h3>
          <p>
            <b>Tanggal : 18 Mei 2020</b> <br>
             Jam : 14.00 - 16.00 WIB
          </p>
          <a @click="openLoginPopup" class="btn-orange" v-if="!account">Login untuk unduh materi</a>
          <a v-else class="btn-orange" href="https://docs.google.com/presentation/d/1IufcEep87p7FXc80vXyXpQvPETTA8N8vz04V8BXiQ4s/edit#slide=id.g8559b22ce7_0_37">Unduh Materi</a>

          <!-- <a class="btn-orange" href="#">Registrasi Disini</a> -->
        </div>
      </div>
      <p><br>Untuk pertanyaan dan partnership hubungi <span style="color:#fa5b33;">halo@docking.id /+6287-885-521-595</span></p>
      <br><br>
    </div>
    <ModalWebinar />
    <ModalLogin @close="closeLoginPopup"/>
  </div>
</template>


<script>
import ModalLogin from '~/components/modal/login'
import ModalWebinar from "~/components/modal/webinar";

export default {
  layout :'default',
  data() {
      return {

      }
    },
  methods: {
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    openLoginPopup() {
			this.$root.$emit('bv::show::modal','modalLogin')
		},
		closeLoginPopup() {
			this.$root.$emit('bv::hide::modal','modalLogin')
		}
  },
  components: {
    ModalWebinar,
    ModalLogin
  },
  computed : {
    account() {
			let data = this.$store.state.account.account;

			if(data && data.type == 'user') data.detail = data.user;
			else if(data && data.type == 'shipyard') data.detail = data.shipyard;
			else if(data && data.type == 'vendor') data.detail = data.vendor;

			return data;
		}
  },
  head() {
    return {
      title: 'DOCKING.ID | Imatap Webinar',
      meta: [
        { name: 'description', hid: 'description', content: 'Docking.id : Indonesia Shipyard and Marine Vendor platform, where ship owners can request, compare and request docking slots for their ships easily with their fingertips.' },
        { name: 'keywords', hid: 'keywords',  content: 'Tentang Docking ID, Galangan Kapal Indonesia, Galangan Kapal Batam, Galangan Kapal Surabaya, Galangan Kapal Jakarta, Galangan Kapal Semarang,Galangan Kapal Sorong, Portal Galangan Kapal Indonesia, Vendor Kapal Batam, Vendor Kapal di Surabaya, Vendor Kapal di Jakarta, Vendor Kapal di Semarang, Perbaikan Kapal' },
        // Open Graph
        { hid: 'og:title', property: 'og:title', content: 'DOCKING.ID : Indonesia Shipyard & Marine Vendor Platform' },
        { hid: 'og:description', property: 'og:description', content: 'Docking.id : Indonesia Shipyard and Marine Vendor platform, where ship owners can request, compare and request docking slots for their ships easily with their fingertips.' },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        { hid: 'og:url', property: 'og:url', content: 'https://www.docking.id/about' },
        { hid: 'og:image', property: 'og:image', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png' },
        // Twitter Card
        { hid: 'twitter:card', property: 'twitter:card', content: 'DOCKING.ID' },
        { hid: 'twitter:site', property: 'twitter:site', content: 'https://www.docking.id' },
        { hid: 'twitter:title', property: 'twitter:title', content: 'DOCKING.ID : Indonesia Shipyard & Marine Vendor Platform'},
        { hid: 'twitter:description', property: 'twitter:description', content: 'Docking.id : Indonesia Shipyard and Marine Vendor platform, where ship owners can request, compare and request docking slots for their ships easily with their fingertips.'},
        { hid: 'twitter:image', property: 'twitter:image', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png'  },
        { hid: 'twitter:image:alt', property: 'twitter:image:alt', content: 'https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png' }
      ]
    }
  }
}
</script>

<style lang="scss">
	@import '~/assets/scss/_mixins.scss';
	@import './style.scss';
</style>
